import { combineReducers } from 'redux';
import auth from './authReducer';
import shopify from './shopifyReducer';
import knowledgeBase from './knowledgeBaseReducer';
import email from './emailReducer';
import widget from './widgetReducer';
import conversations from './conversationsReducer';
import adminConversations from './adminConversationsReducer';
import voice from './voiceReducer';
import billing from './billingReducer';
import payment from './paymentReducer';
import language from './languageReducer';
import redo from './redoReducer';
import users from './usersReducer';
import agency from './agencyReducer';
import agencyWidget from './agencyWidgetReducer';
import userPackage from './userPackageReducer';
import userPackagesLog from './userPackagesLogReducer';
import terms from './termsReducer';
import packages from './packagesReducer';
import callPackages from './callPackagesReducer';
import events from './eventsReducer';
import changePassword from './changePasswordReducer';
import defaultPrompt from './defaultPromptReducer';
import agentTools from './agentToolsReducer';
import defaultVoicePrompt from './defaultVoicePromptReducer';
import globalVoicePrompt from './globalVoicePromptReducer';
import ups from './upsReducer';
import supressEmail from './supressEmailReducer';

const rootReducer = combineReducers({
  auth,
  shopify,
  knowledgeBase,
  email,
  widget,
  conversations,
  adminConversations,
  voice,
  billing,
  payment,
  language,
  redo,
  users,
  agency,
  agencyWidget,
  userPackage,
  userPackagesLog,
  terms,
  packages,
  callPackages,
  events,
  changePassword,
  defaultPrompt,
  agentTools,
  defaultVoicePrompt,
  globalVoicePrompt,
  ups,
  supressEmail,
});

export default rootReducer;
